import React, { useState, useEffect } from "react";
import { Button, Modal, Form, Input, message, Popconfirm } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { deleteApi, postApi } from "../redux/rest/restSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import {
  UPDATE_ADVERTISEMENT,
  DELETE_ADVERTISEMENT,
} from "../constants/actionTypes";
import { PERMISSIONS } from "./permissions";
import Can from "../components/Can";

export const AdvertisementForm = ({
  visible,
  onCancel,
  onSubmit,
  initialValues,
}) => {
  const [form] = Form.useForm();

  // Populate form fields when initialValues change
  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        advertisement_name: initialValues.advertisement_name,
        advertisement_url: initialValues.advertisement_url,
      });
    } else {
      form.resetFields();
    }
  }, [initialValues, form]);

  return (
    <Modal
      title={initialValues ? "Update Advertisement" : "Create Advertisement"}
      open={visible}
      onCancel={onCancel}
      onOk={() => form.submit()}
    >
      <Form form={form} onFinish={onSubmit} layout="vertical">
        <Form.Item
          name="advertisement_name"
          label="Advertisement Name"
          rules={[{ required: true, message: "Please enter a name" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="advertisement_url"
          label="Advertisement URL"
          rules={[{ required: true, message: "Please enter a URL" }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const advertisementTables = (refreshList, canUpdateAdvertisement) => {
  return [
    {
      title: "Sr. No",
      dataIndex: "index",
      key: "index",
      className: "col-index",
      width: 72,
      responsive: ["sm"],
      render: (text, record, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "advertisement_name",
      key: "advertisement_name",
    },
    {
      title: "URL",
      dataIndex: "advertisement_url",
      key: "advertisement_url",
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "right",
      className: "col-actions",
      fixed: "right",
      hidden: !canUpdateAdvertisement,
      render: (text, record) => (
        <AdvertisementActions record={record} refreshList={refreshList} />
      ),
    },
  ];
};

// const AdvertisementActions = ({ record, refreshList }) => {
//     const [modalVisible, setModalVisible] = useState(false);
//     const dispatch = useDispatch();

//     const handleUpdate = (values) => {
//         const payload = {
//             id: record.id,  // Include the ID from the list response
//             advertisement_name: values.advertisement_name,
//             advertisement_url: values.advertisement_url,
//         };

//         dispatch(postApi({ endpoint: UPDATE_ADVERTISEMENT, payload }))
//             .then(unwrapResult)
//             .then((result) => {
//                 if (result.success) {
//                     message.success('Advertisement updated successfully');
//                     setModalVisible(false);
//                     refreshList();
//                 }
//             })
//             .catch(() => {
//                 message.error('Failed to update advertisement');
//             });
//     };

//     return (
//         <>
//             <Button type="link" onClick={() => setModalVisible(true)}>Update</Button>
//             <AdvertisementForm
//                 visible={modalVisible}
//                 onCancel={() => setModalVisible(false)}
//                 onSubmit={handleUpdate}
//                 initialValues={record}
//             />
//         </>
//     );
// };

const AdvertisementActions = ({ record, refreshList }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const dispatch = useDispatch();

  const handleUpdate = (values) => {
    const payload = {
      id: record.id,
      advertisement_name: values.advertisement_name,
      advertisement_url: values.advertisement_url,
    };

    dispatch(postApi({ endpoint: UPDATE_ADVERTISEMENT, payload }))
      .then(unwrapResult)
      .then((result) => {
        if (result.success) {
          message.success("Advertisement updated successfully");
          setModalVisible(false);
          refreshList();
        }
      })
      .catch(() => {
        message.error("Failed to update advertisement");
      });
  };

  const handleDelete = () => {
    dispatch(
      deleteApi({
        endpoint: `${DELETE_ADVERTISEMENT}/${record.id}`,
      }),
    )
      .then(unwrapResult)
      .then((result) => {
        if (result.success) {
          message.success("Advertisement deleted successfully");
          refreshList();
        }
      })
      .catch(() => {
        // message.error("Failed to delete advertisement");
      });
  };

  return (
    <>
      <div className="d-flex" style={{ gap: 8, justifyContent: "flex-end" }}>
        <Can permissions={[PERMISSIONS.UPDATE_ADVERTISEMENTS]}>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => setModalVisible(true)}
          >
            Update
          </Button>
        </Can>

        <Can permissions={[PERMISSIONS.DELETE_ADVERTISEMENT]}>
          <Popconfirm
            title="Are you sure you want to delete this advertisement?"
            onConfirm={handleDelete}
            okText="Yes"
            cancelText="No"
          >
            <Button danger type="primary" icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </Can>
      </div>

      <AdvertisementForm
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onSubmit={handleUpdate}
        initialValues={record}
      />
    </>
  );
};
